import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

import { ChangeDetectionStrategy, Component, computed, effect, inject, input, resource } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";

import { FooterComponent } from "../../../../../components/common/footer/footer";
import { LoaderComponent } from "../../../../../components/common/loader/loader";
import { DEFAULT_LANGUAGE } from "../../../../constants";
import { NEWS_REPOSITORY } from "../../../domain/ports/news-repository.port";
import { NavigationNews } from "../../components/navigation-news/navigation-news.component";
import { NewsItemComponent } from "../../components/news-item/news-item.component";

@Component({
  selector: "news-page",
  templateUrl: "./news.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NavigationNews, NewsItemComponent, LoaderComponent, TranslatePipe, FooterComponent],
})
export class Newspage {
  protected lang = input<string>(DEFAULT_LANGUAGE);
  protected newsItemId = input<string | undefined>();
  public newsItem = computed(() => this.news().find((i) => i.newsItemId === this.newsItemId()));

  private router = inject(Router);
  private newsService = inject(NEWS_REPOSITORY);
  private title = inject(Title);
  private translate = inject(TranslateService);

  protected news = computed(() => this._news.value());
  private _news = resource({
    params: () => ({ lang: this.lang() }),
    loader: ({ params }) => this.newsService.getNewsItemsForLanguage(params.lang).catch(() => []),
    defaultValue: [],
  });

  public static TITLE_KEY = "Navigation.News";
  titleTranslated = toSignal(this.translate.stream(Newspage.TITLE_KEY) as Observable<string>);
  updateTitle = effect(() => this.title.setTitle(`SURFnet ${(this.titleTranslated() ?? "").toLowerCase()}`));

  constructor() {
    effect(() => {
      if (this.translate.getLangs().includes(this.lang())) {
        this.translate.use(this.lang());
      } else {
        this.navigateToLanguage(DEFAULT_LANGUAGE);
      }
    });
  }

  public navigateToLanguage = (lang: string) => this.router.navigate(["news", lang]);
}
